// high-contrast-theme.ts
import { createTheme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import { signature, radius, typography, support } from "./theme-tokens";

const hc = createTheme({
    layout: {
        mobile: {
            menu: {
                drawer: {
                    width: '90vw'
                }
            }
        }
    },
    palette: {
        mode: "dark", // Start from dark for true high contrast
        primary: {
            main: signature.main,
            // Keep tones tighter to avoid mid-contrast states
            light: signature[400],
            dark: signature[800],
            contrastText: "#000000", // Black on yellow for maximum readability
        },
        secondary: {
            main: "#FFFFFF",
            contrastText: "#000000",
        },
        breakout: support.breakout,
        background: {
            default: "#000000",
            paper: "#000000",
            dark: "#000000",
        },
        text: {
            primary: "#FFFFFF",
            secondary: alpha("#FFFFFF", 0.82),
            disabled: alpha("#FFFFFF", 0.5),
        },
        divider: alpha("#FFFFFF", 0.4),
        error: { main: "#FF514A", contrastText: "#000" },
        warning: { main: "#FFC107", contrastText: "#000" },
        info: { main: "#64B5F6", contrastText: "#000" },
        success: { main: "#7DFFA0", contrastText: "#000" },
        action: {
            active: "#FFFFFF",
            hover: alpha("#FFFFFF", 0.12),
            selected: alpha("#FFFFFF", 0.2),
            disabled: alpha("#FFFFFF", 0.5),
            disabledBackground: alpha("#FFFFFF", 0.08),
            focus: alpha("#FFFFFF", 0.5),
        },
    },
    // @ts-expect-error - ignore
    typography: {
        ...typography,
        // Slightly larger base for readability
        body1: { ...typography.body1, fontSize: 18 },
        body2: { ...typography.body2, fontSize: 16 },
    },
    shape: { borderRadius: radius.xs },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: { backgroundColor: "#000", color: "#fff" },
                '*:focus-visible': {
                    outline: '3px solid #FFFFFF',
                    outlineOffset: 3,
                },
                '@media (prefers-reduced-motion: reduce)': {
                    '*': { animationDuration: '0.01ms !important', animationIterationCount: '1 !important', transitionDuration: '0.01ms !important', scrollBehavior: 'auto !important' },
                },
            },
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: {
                    borderRadius: radius.xs,
                    border: '2px solid #FFFFFF',
                    // Guarantee contrast of states
                    '&:hover': { backgroundColor: signature[400], color: '#000' },
                    '&.Mui-disabled': { borderColor: alpha('#FFFFFF', 0.5) },
                },
                containedPrimary: { color: '#000' },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#FFFFFF',
                    textDecoration: 'underline',
                    textUnderlineOffset: 3,
                    '&:hover': { color: signature[300] },
                },
            },
        },
        MuiPaper: {
            defaultProps: { elevation: 0 },
            styleOverrides: { root: { backgroundColor: '#000', color: '#fff', border: '2px solid #fff' } },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: { color: '#FFFFFF' },
            },
        },
        MuiSwitch: {
            styleOverrides: {
                track: { backgroundColor: '#FFFFFF' },
                thumb: { backgroundColor: signature.main },
            },
        },
    },
});

export default hc;